import { APP_PATHS } from "./paths";

export const CART_CRUMBS = [
  { url: APP_PATHS.HOME.url, label: APP_PATHS.HOME.label },
  { label: APP_PATHS.CART.label },
];

export const HOME_CRUMBS = [
  { url: APP_PATHS.HOME.url, label: APP_PATHS.HOME.label },
];

export const VOICE_ORDER_CRUMBS = [
  { url: APP_PATHS.HOME.url, label: APP_PATHS.HOME.label },
  { label: APP_PATHS.VOICE_ORDER.label },
];

export const PROFILE_CRUMBS = [
  { url: APP_PATHS.HOME.url, label: APP_PATHS.HOME.label },
  { label: APP_PATHS.PROFILE.label },
];

export const PROFILE_WALLET_CRUMBS = [
  { url: APP_PATHS.HOME.url, label: APP_PATHS.HOME.label },
  { label: APP_PATHS.WALLET.label },
];

export const PROFILE_PREVIOUS_ORDERS_CRUMBS = [
  { url: APP_PATHS.HOME.url, label: APP_PATHS.HOME.label },
  { label: APP_PATHS.PREVIOUS_ORDERS.label },
];

export const SKU_DETAILS_CRUMBS = [
  { url: APP_PATHS.HOME.url, label: APP_PATHS.HOME.label },
  { label: APP_PATHS.SKU_DETAILS.label },
];

export const BUNDLE_DETAILS_CRUMBS = [
  { url: APP_PATHS.HOME.url, label: APP_PATHS.HOME.label },
  { label: APP_PATHS.BUNDLE_DETAILS.label },
];

export const SKUS_CRUMBS = [
  { url: APP_PATHS.HOME.url, label: APP_PATHS.HOME.label },
];

export const BUNDLE_CRUMBS = [
  { url: APP_PATHS.HOME.url, label: APP_PATHS.HOME.label },
  { label: APP_PATHS.BUNDLES.label },
];

export const NEW_SKUS_CRUMBS = [
  { url: APP_PATHS.HOME.url, label: APP_PATHS.HOME.label },
  { label: APP_PATHS.NEW_SKUS.label },
];

export const RECOMMEDED_SKUS_CRUMBS = [
  { url: APP_PATHS.HOME.url, label: APP_PATHS.HOME.label },
  {
    label: APP_PATHS.RECOMMENDED_SKUS.label,
  },
];

export const PROMOTIONS_CRUMBS = [
  { url: APP_PATHS.HOME.url, label: APP_PATHS.HOME.label },
  {
    label: APP_PATHS.PROMOTIONS.label,
  },
];

export const PENDING_ORDERS_CRUMBS = [
  { url: APP_PATHS.HOME.url, label: APP_PATHS.HOME.label },
  {
    label: APP_PATHS.PENDING_ORDERS.label,
  },
];

export const PRICED_ORDERS_CRUMBS = [
  { url: APP_PATHS.HOME.url, label: APP_PATHS.HOME.label },
  {
    label: APP_PATHS.PRICED_ORDERS.label,
  },
];

export const PRICED_ORDER_ITEMS_CRUMBS = [
  { url: APP_PATHS.HOME.url, label: APP_PATHS.HOME.label },
  {
    label: APP_PATHS.PRICED_ORDER_ITEMS.label,
  },
];
